import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
	providedIn: 'root'
})
export class MatSnackBarService {

	constructor(private matSnackBar:MatSnackBar) { }

	show(tone:"success"|"error"|"neutral", caption:string) {
		this.matSnackBar.open(caption, undefined, {
			panelClass: [tone],
			verticalPosition: "bottom",
			horizontalPosition: "center"
		});
	}

	withAction(tone:"success"|"error", caption:string, buttonCaption:string, callback:()=>void) {
		this.matSnackBar.open(caption, buttonCaption, {
			panelClass: [tone],
			duration: 8500,
			verticalPosition: "bottom",
			horizontalPosition: "center"
		}).onAction().subscribe(()=> {
			callback();
		});
	}
}
